module.exports = __webpack_public_path__ + "img/merida.12fdfd83.png";